import * as React from "react";

interface Props {
    label:string;
    name: string; 
    value:string | undefined; 
    error: boolean;
    handleChange:any;
    options: string[]
}

const Select: React.FC<Props> = (props) => {
  const {
    label, name, value, error, handleChange, options
    
  } = props;

  return (
    <>
      <div
        className="inline"
        style={{
          width: "50%",
          marginBottom: "2px",
          color: error ? "red" : "black",
        }}
      >
        {label}
      </div>
      <div className="inline" style={{ width: "50%", marginBottom: "2px" }}>
        <select id={name} name={name} value={value} onChange={handleChange} style={{ width: "100%" }}>
          {options.map((option) => (
            <option key={option} value={option}>{option}</option>
          ))}
        </select>
      </div>
    </>
  );
};

export default Select;
